// removed by extract-text-webpack-plugin
module.exports = {"root":"_6f7e269d","loader":"c3d16308"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AppointmentForm/AppointmentVisitDetails/styles.styl
// module id = 4906
// module chunks = 39